module.exports = __webpack_public_path__ + "img/bill1.e98de73e.png";